import React, { useEffect } from 'react';

import { LockOutlined, ApiOutlined, KeyOutlined, IdcardOutlined } from '@ant-design/icons';
import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';
import { Form, Input, Alert } from 'antd';
import { useTranslation } from 'react-i18next';


const ShopifyCredentials = ({ form, ecAccount, useCustomApp = false }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (ecAccount?.credentials) {
      form.setFieldsValue({ credentials: ecAccount.credentials });
    }
  }, [ecAccount]);

  const isEditing = !!ecAccount?.id;
  const clientSecretDirty = useDirtyMaskedField(form, ['credentials', 'client_secret'], isEditing);

  const credentials = form.getFieldValue('credentials') || {};
  const isAuthorized = credentials.access_token && credentials.api_domain;

  if (isAuthorized) {
    return (
      <Alert
        message={t('models.ec_account.platform_settings.shopify.authorized')}
        description={
          <div>
            <strong>{t('models.ec_account.platform_settings.shopify.merchant_domain')}:</strong> {credentials.api_domain}
          </div>
        }
        type="success"
        showIcon
        icon={<LockOutlined />}
      />
    );
  }

  return (
    <div>
      <Alert
        message={t('models.ec_account.platform_settings.shopify.not_authorized')}
        description={t('models.ec_account.platform_settings.shopify.authorization_required')}
        type="warning"
        showIcon
        style={{ marginBottom: '16px' }}
      />

      <Form.Item
        name={['credentials', 'api_domain']}
        label={t('models.ec_account.platform_settings.shopify.api_domain')}
        rules={[{ required: true, message: t('models.ec_account.platform_settings.shopify.api_domain_required') }]}
      >
        <Input
          placeholder={t('models.ec_account.platform_settings.shopify.api_domain_placeholder')}
          prefix={<ApiOutlined />}
        />
      </Form.Item>

      {useCustomApp && (
        <>
          <Form.Item
            name={['credentials', 'client_id']}
            label={t('models.ec_account.platform_settings.shopify.client_id')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.shopify.client_id_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.shopify.client_id_placeholder')}
              prefix={<IdcardOutlined />}
            />
          </Form.Item>

          <Form.Item
            name={['credentials', 'client_secret']}
            label={t('models.ec_account.platform_settings.shopify.client_secret')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.shopify.client_secret_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.shopify.client_secret_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={clientSecretDirty}
            />
          </Form.Item>
        </>
      )}
    </div>
  );
};

export default ShopifyCredentials;
